import { render, staticRenderFns } from "./PtNodata.vue?vue&type=template&id=261e1dba"
import script from "./PtNodata.vue?vue&type=script&lang=js"
export * from "./PtNodata.vue?vue&type=script&lang=js"
import style0 from "./PtNodata.vue?vue&type=style&index=0&id=261e1dba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports